var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"handle"},[_c('el-button',[_vm._v("批量移除")]),_c('el-button',[_vm._v("导入名单")]),_c('el-button',{attrs:{"type":"primary"}},[_vm._v("名单管理")])],1),_c('Table',{attrs:{"data":_vm.persons,"row-key":"uuid"},on:{"selection-change":_vm.selectChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }